import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da4d9a38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col flex-1 h-full min-h-0 bg-primary" }
const _hoisted_2 = { class: "flex flex-col flex-1 pt-5 pb-4 overflow-y-auto" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center flex-shrink-0 px-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-auto h-8",
    src: "/assets/logo_header_2x.png",
    alt: "Workflow"
  })
], -1))
const _hoisted_4 = {
  class: "flex-1 px-2 mt-5 space-y-1",
  "aria-label": "Sidebar"
}
const _hoisted_5 = {
  key: 0,
  class: "flex flex-shrink-0 p-4 border-t border-indigo-800 md:hidden lg:hidden xl:hidden 2xl:hidden"
}
const _hoisted_6 = { class: "flex-shrink-0 block w-full group" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "ml-3" }
const _hoisted_10 = { class: "text-sm font-medium text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_menu_item = _resolveComponent("menu-item")!
  const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!

  return (_openBlock(), _createBlock(_component_ion_menu, {
    "content-id": "main-content",
    type: "overlay"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("nav", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (item) => {
                  return (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                    "auto-hide": "false",
                    key: item.name
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showItem(item))
                        ? (_openBlock(), _createBlock(_component_menu_item, {
                            key: 0,
                            item: item
                          }, null, 8, ["item"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ]),
            (_ctx.user)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", null, [
                        _createElementVNode("img", {
                          class: "inline-block rounded-full h-9 w-9",
                          src: _ctx.user.avatarUrl,
                          alt: ""
                        }, null, 8, _hoisted_8)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.user.firstname + " " + _ctx.user.lastname), 1),
                        _createElementVNode("p", {
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
                          class: "text-xs font-medium text-indigo-200 cursor-pointer group-hover:text-white"
                        }, _toDisplayString(_ctx.t("menu.Logout")), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}